const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const ChooseOptionModal = require("./ChooseOptionModal");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withSetURL = require("../hoc/withSetURL");
const {atPage} = require("../vault/StateCursors");
const Derived = require("../vault/Derived");
const URLMake = require("../../../shared/URLMake");
const CopyTable = require("../util/CopyTable");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withSetURL(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		page: atPage(vaultState).get(),
		styleType: Derived.getCurrentModalStyle(vaultState),
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ConfirmPageNavigation",

		propTypes: {
			// Injected by HOCs
			page: PT.object.isRequired,
			styleType: PT.string.isRequired,
			setURL: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			confirmPageNavigation: function(confirmType, confirmHref, confirmData) {
				this.setState({
					isModalOpen: true,
					confirmType,
					confirmHref,
					confirmData,
				});
			},
			resetVaultState: function() {
				this.setState({isModalOpen: false});
			},
		},

		getInitialState: function() {
			return {
				isModalOpen: false,
			};
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			// Close the modal if we changed pages and the modal was open.
			if (this.state && this.state.isModalOpen) {
				const modalURL = URLMake.forPageState(this.props.page);
				const newURL = URLMake.forPageState(nextProps.page);
				if (modalURL !== newURL) {
					this.setState({isModalOpen: false});
				}
			}
		},

		confirmNavigation: function() {
			this.setState({isModalOpen: false});
			this.props.setURL(this.state.confirmHref, {confirmed: true});
		},

		getMessage: function(confirmType, confirmData) {
			if (confirmType === "leaveResult") {
				return CopyTable.forLeaveResult(confirmData);
			}
		},

		render: function() {
			let modal = null;
			if (this.state.isModalOpen) {
				const handleModalClose = () => this.setState({isModalOpen: false});
				modal = (
					<ChooseOptionModal
						styleType={this.props.styleType}
						buttons={[
							{buttonType: "yes", handleClick: this.confirmNavigation},
							{buttonType: "cancel", handleClick: handleModalClose},
						]}
						onClose={handleModalClose}
						gatewayType={null}
					>
						{this.getMessage(this.state.confirmType, this.state.confirmData)}
					</ChooseOptionModal>
				);
			}
			return modal;
		},
	})
);
